import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "copyButton"]

  copy() {
    const codeElement = this.activeCodeContent
    if (!codeElement) return

    let text = codeElement.dataset.copyText ?? codeElement.innerText

    if (codeElement.classList.contains("language-curl-example")) {
      text = this.#cleanCodeText(text)
    }

    this.copyToClipboard(text)
    this.updateCopyButtonState()
  }

  #cleanCodeText(text) {
    return text.replace(/^\s*\$ /gm, "")
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text)
  }

  updateCopyButtonState() {
    const originalAriaLabel = this.copyButtonTarget.getAttribute("aria-label")
    this.copyButtonTarget.setAttribute("aria-label", "Copied")

    setTimeout(() => {
      this.copyButtonTarget.setAttribute("aria-label", originalAriaLabel)
    }, 2000)
  }

  get activeCodeContent() {
    const contentTarget = this.contentTargets[0]
    const selectors = [
      "pre.active",
      "[data-doc-examples-target='example'].active",
      "[data-doc-examples-target='example']:has(pre.active)"
    ]

    for (const selector of selectors) {
      const element = contentTarget.querySelector(selector)
      if (element) {
        return element.querySelector("code")
      }
    }

    // If no selector is active, take the first pre code
    const firstCode = contentTarget.querySelector("pre code")
    return firstCode || null
  }
}
